// extracted by mini-css-extract-plugin
export default {"container":"CookiePolicyContainer_container__TvlgC","buttonSection":"CookiePolicyContainer_buttonSection__G-Am7"};